/* assets/demon-media-grid.js */
(function () {
  const VISIBLE = 5;
  const MQ = window.matchMedia("(min-width: 750px)");
  let rebuildTimer = null;
  let observer = null;

  function log() {
    console.log("[DEMON GRID]", ...arguments);
  }

  function isDesktop() {
    return MQ.matches;
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function getMainGallery() {
    return (
      qs("media-gallery") ||
      qs("#MediaGallery") ||
      qs(".product__media-wrapper") ||
      qs(".product__media") ||
      qs("[data-media-gallery]") ||
      qs(".media-gallery")
    );
  }

  function getThumbContainer() {
    return (
      qs("[id*='GalleryThumbnails']") ||
      qs("thumbnail-slider") ||
      qs(".thumbnail-slider") ||
      qs(".product__media-thumbnails") ||
      qs(".thumbnails") ||
      qs(".product-media-thumbs") ||
      qs(".slider-mobile-gutter")
    );
  }

  function getThumbNodes() {
    const container = getThumbContainer();
    if (!container) return [];

    const raw = qsa(
      [
        ".thumbnail-slider__item",
        ".product__media-thumbnail",
        "[data-target]",
        "[data-media-id]",
        "[data-thumbnail-id]",
        "button",
        "a"
      ].join(","),
      container
    );

    const seen = new Set();
    const result = [];

    raw.forEach((node) => {
      const img = node.querySelector("img");
      const key =
        node.getAttribute("data-target") ||
        node.getAttribute("data-media-id") ||
        node.getAttribute("data-thumbnail-id") ||
        img?.getAttribute("src") ||
        img?.getAttribute("data-src") ||
        img?.currentSrc;

      if (!key || seen.has(key)) return;
      seen.add(key);
      result.push(node);
    });

    return result;
  }

  function normalizeSrc(src) {
    if (!src) return "";
    let s = src.trim();
    if (s.startsWith("//")) s = window.location.protocol + s;
    if (s.startsWith("/")) s = window.location.origin + s;
    return s;
  }

  function getThumbImage(node) {
    return node.querySelector("img");
  }

  function createCard(thumb, index) {
    const thumbImg = getThumbImage(thumb);
    if (!thumbImg) return null;

    const src = normalizeSrc(
      thumbImg.getAttribute("src") ||
      thumbImg.getAttribute("data-src") ||
      thumbImg.getAttribute("data-lazy-src") ||
      thumbImg.currentSrc
    );

    if (!src) return null;

    const card = document.createElement("button");
    card.type = "button";
    card.className = "demon-media-card";
    card.setAttribute("data-demon-index", String(index));

    const img = document.createElement("img");
    img.src = src;
    img.alt = thumbImg.getAttribute("alt") || "";
    img.loading = index < 6 ? "eager" : "lazy";

    card.appendChild(img);

    card.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const target =
        thumb.matches("button, a") ? thumb : thumb.querySelector("button, a") || thumb;

      if (target) {
        target.click();
      }
    });

    return card;
  }

  function destroyCustomGallery() {
    qsa(".demon-desktop-gallery").forEach((el) => el.remove());
    qsa(".demon-force-hidden").forEach((el) => {
      el.classList.remove("demon-force-hidden");
      el.removeAttribute("data-demon-hidden");
    });
  }

  function hideOriginalGalleryStrong() {
    const gallery = getMainGallery();
    if (!gallery) return [];

    const candidates = [
      gallery,
      gallery.closest(".product__media-wrapper"),
      gallery.closest(".product__media"),
      gallery.closest(".product__column-sticky"),
      gallery.closest(".grid__item"),
      gallery.parentElement
    ].filter(Boolean);

    const unique = [];
    const seen = new Set();

    candidates.forEach((el) => {
      if (!el || seen.has(el)) return;
      seen.add(el);
      unique.push(el);
    });

    unique.forEach((el, i) => {
      el.classList.add("demon-force-hidden");
      el.setAttribute("data-demon-hidden", "true");
      log("hide candidate", i, el);
    });

    return unique;
  }

  function buildCustomGallery() {
    destroyCustomGallery();

    if (!isDesktop()) {
      log("mobile: skip");
      return;
    }

    const gallery = getMainGallery();
    const thumbs = getThumbNodes();

    log("main gallery =", gallery);
    log("thumb container =", getThumbContainer());
    log("thumb count =", thumbs.length);

    if (!gallery) {
      log("NO main gallery found");
      return;
    }

    if (thumbs.length < 2) {
      log("NO enough thumbs found");
      return;
    }

    const wrap = document.createElement("div");
    wrap.className = "demon-desktop-gallery";

    const grid = document.createElement("div");
    grid.className = "demon-media-grid";
    wrap.appendChild(grid);

    const total = thumbs.length;
    const shown = Math.min(VISIBLE, total);
    const more = Math.max(0, total - VISIBLE);

    thumbs.slice(0, shown).forEach((thumb, i) => {
      const card = createCard(thumb, i);
      if (card) grid.appendChild(card);
    });

    if (total > VISIBLE) {
      const toggleWrap = document.createElement("div");
      toggleWrap.className = "demon-toggle-wrap";

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "button demon-toggle-btn";
      btn.innerHTML = `Vedi altre <span class="count">+${more}</span>`;
      toggleWrap.appendChild(btn);
      wrap.appendChild(toggleWrap);

      const acc = document.createElement("div");
      acc.className = "demon-media-accordion";

      const accGrid = document.createElement("div");
      accGrid.className = "demon-media-accordion-grid";
      acc.appendChild(accGrid);
      wrap.appendChild(acc);

      thumbs.slice(VISIBLE).forEach((thumb, i) => {
        const card = createCard(thumb, i + VISIBLE);
        if (card) accGrid.appendChild(card);
      });

      let open = false;

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        open = !open;

        if (open) {
          acc.classList.add("is-open");
          acc.style.maxHeight = acc.scrollHeight + "px";
        } else {
          acc.classList.remove("is-open");
          acc.style.maxHeight = "0px";
        }

        btn.innerHTML = open ? "Chiudi" : `Vedi altre <span class="count">+${more}</span>`;
      });
    }

    gallery.insertAdjacentElement("beforebegin", wrap);
    log("custom gallery inserted", wrap);

    hideOriginalGalleryStrong();
  }

  function scheduleRebuild() {
    clearTimeout(rebuildTimer);
    rebuildTimer = setTimeout(buildCustomGallery, 250);
  }

  function hookChanges() {
    document.addEventListener("change", function (e) {
      if (e.target.closest(".demon-desktop-gallery")) return;
      if (e.target.closest("form[action*='/cart/add'], form.product-form")) {
        scheduleRebuild();
      }
    });

    document.addEventListener("click", function (e) {
      if (e.target.closest(".demon-desktop-gallery")) return;

      if (
        e.target.closest(
          [
            "[data-option]",
            ".product-form__input",
            ".variant",
            ".swatch",
            ".thumbnail-slider__button",
            ".product__media-thumbnail",
            ".thumbnail-slider__item"
          ].join(",")
        )
      ) {
        scheduleRebuild();
      }
    });

    if (observer) observer.disconnect();

    observer = new MutationObserver(function (mutations) {
      for (const m of mutations) {
        const target = m.target && (m.target.nodeType === 1 ? m.target : m.target.parentElement);
        if (target && target.closest && target.closest(".demon-desktop-gallery")) continue;

        if ((m.addedNodes && m.addedNodes.length) || (m.removedNodes && m.removedNodes.length)) {
          scheduleRebuild();
          break;
        }
      }
    });

    const root = document.querySelector("main") || document.body;
    observer.observe(root, { childList: true, subtree: true });

    MQ.addEventListener("change", scheduleRebuild);
  }

  function init() {
    log("init");
    buildCustomGallery();
    hookChanges();

    let tries = 0;
    const t = setInterval(() => {
      tries++;
      buildCustomGallery();
      if (tries > 8) clearInterval(t);
    }, 500);
  }

  document.addEventListener("DOMContentLoaded", init);
})();